/* eslint-disable sort-keys, max-len */
export default {
    // bidding console
    bidding_console: {
        console: {
            button: {
                login: '登录以竞投',
                signup: '注册以竞投',
                register_long: '注册拍卖',
                pending: '注册正待处理',
                declined: '注册已被拒绝',
                closed: '拍卖品已关闭',
                sent: '您的出价已经发送',
                outbid: '您的出价被超越, 出价{amount}美金',
                bid: '您的出价被超越, 出价{amount}美金',
                winning: '您正在赢胜',
            },
            conversions: {
                lot_number: '拍卖品{lotNumber}',
            },
            description: {
                estimate_range: '估价{low} - {high}美金',
                images_label: '{currentImageNumber} / {totalImages}',
            },
            messages: {
                competing_bid_amount: '{amount}美金: 竞标',
                competing_bidder_outbid_by_liveauctioneers_absentee: '投标人{paddleNumber}的缺席竞标已超越竞标人出价',
                last_bid_retracted: '最后出价{amount}美元已被撤回',
                liveauctioneers_bid_amount: '{amount}美金: LiveAuctioneers投标人{paddleNumber}',
                liveauctioneers_bid_amount_absentee: '{amount}美金: LiveAuctioneers投标人{paddleNumber}之缺席竞标',
                lot_number_passed: '拍卖品{lotNumber}流标',
                lot_number_reopened: '拍卖品{lotNumber}重新开放',
                lot_number_skipped: '拍卖品{lotNumber}已跳过',
                lot_number_unsold: '拍卖品{lotNumber}未达底标',
                lot_opened_asking: '拍卖品{lotNumber}已开放 - 要价{amount}美金',
                lot_sold_competing_bidder: '拍卖品{lotNumber}卖了{amount}美金由竞标人拍得',
                lot_sold_liveauctioneers_bidder: '拍卖品{lotNumber}卖了{amount}美金由投标人{paddleNumber}拍得',
                my_bid_amount: '{amount}美金: 我的出价',
                my_bid_amount_absentee: '{amount}美金: 我的缺席竞投',
                my_bid_retracted: '您的{amount}美元出价已被撤回',
                registration_approved: '您的注册已获批准',
                reserve_not_met: '未至底价',
                you_been_outbid_by_liveauctioneers_absentee: '投标人{paddleNumber}的缺席竞标已超越您的出价',
                you_ve_won_lot: '您拍得了拍卖品{lotNumber}',
            },
            missives: {
                fair_warning_lot_about_to_close: '拍卖官警告... 此拍卖品即将关闭',
                going_once_going_twice: '一次... 两次...',
                third_and_final_warning: '三次和最后警告...',
            },
            status: {
                remaining: '{total}件拍卖品中剩余{remaining}件',
            },
            thumbnail_scroller: {
                next: '下一拍卖品',
            },
        },
    },
};
